<script setup lang="ts">
// merchant-pc 根组件 (PR-22a-3 stub, 单 router-view 占位)
</script>

<template>
  <!-- F76/F78: changing orders ends the old detail session and its pending actions. -->
  <router-view v-slot="{ Component, route }">
    <component :is="Component" :key="route.name === 'p08a-order-detail' ? String(route.params.orderId ?? route.query.orderId ?? '') : undefined" />
  </router-view>
</template>
